/*
Descrição..........: Arquivo ts, que contém as funções necessárias
Autor..............: Pablo Ebbers
Data Criação.......: 01/03/2020
Última Atualização.: 17/03/2020


Funções/Métodos:
-----
async loadCategory(id: number) retorno: um registro
Recebe um ID e consultando o service retorna um registro específico
-----
async onSubmit() retorno: nenhum
Função que é acionada ao clicar do botão no formulário de cadastro ou alteração
 e leva os dados até o service para que seja inserido ou alterado no banco de dados
-----
*/
import { Component, OnInit } from '@angular/core';
import { Categoria } from 'src/app/model/categoria';
import { ToastService } from 'src/app/core/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoriaApiService } from 'src/app/dao/api_categoria.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from 'src/app/dao/global.service';
import { AlertController } from '@ionic/angular';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { Produto } from 'src/app/model/produto';
import { ApiGruposopcionaisService } from 'src/app/dao/api-gruposopcionais.service';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';

@Component({
  selector: 'app-categoria-form',
  templateUrl: './categoria-form.page.html',
  styleUrls: ['./categoria-form.page.scss'],
})
export class CategoriaFormPage implements OnInit {
  title = 'Nova categoria';
  category: Categoria;
  dominio;
  fileToUpload: File = null;
  produtos: Produto[] = [];
  imgPath;
  validado = false;
  validador;
  senhaGerada;
  diaAtual = new Date().getDate();
  horaAtual = new Date().getHours();
  anoAtual = new Date().getFullYear();
  displayModal = false;
  dominioDestino;
  catDestino;
  mostrarEnviar = false;
  comOpcs = false;
  idCatParam;
  plano;
  
  exibirDia0 = false;
  exibirDia1 = false;
  exibirDia2 = false;
  exibirDia3 = false;
  exibirDia4 = false;
  exibirDia5 = false;
  exibirDia6 = false;
  exibirDiaTodos = false;
  novosDiasExibir;
  disableVar = false;
  carregando = false;

  rotas = [];


  constructor(private apiUnidade: UnidadeApiService, private unidadeService: UnidadeApiService, private gruposOpcionalService: ApiGruposopcionaisService, private apiproduto: ProdutoapiService, private router: Router, public alertController: AlertController, private route: ActivatedRoute, private global: GlobalService, private http: HttpClient, private toast: ToastService, private apiCategoria: CategoriaApiService) { }

  ngOnInit() {
    
    this.plano = this.global.plano;
    this.senhaGerada = (((this.diaAtual * this.horaAtual) * this.anoAtual) - this.diaAtual);
    this.category = new Categoria();
    this.dominio = this.global.dominio;
    this.carregarRotas();
    const idParam = this.route.snapshot.paramMap.get('id');
    this.idCatParam = idParam
    if (idParam) {
      this.title = 'Editar categoria';
      // tslint:disable-next-line: radix
      this.loadCategory(parseInt(idParam));
    }
  }

  ionViewWillEnter() {
    this.plano = this.global.plano;
    this.senhaGerada = (((this.diaAtual * this.horaAtual) * this.anoAtual) - this.diaAtual);
    this.category = new Categoria();
    this.dominio = this.global.dominio;
    this.carregarRotas();
    const idParam = this.route.snapshot.paramMap.get('id');
    this.idCatParam = idParam
    if (idParam) {
      this.title = 'Editar categoria';
      // tslint:disable-next-line: radix
      this.loadCategory(parseInt(idParam));
    }
  }


  selecionarTodos(){
    if(this.exibirDiaTodos){
      this.exibirDia0 = true;
      this.exibirDia1 = true;
      this.exibirDia2 = true;
      this.exibirDia3 = true;
      this.exibirDia4 = true;
      this.exibirDia5 = true;
      this.exibirDia6 = true;
      this.disableVar = true;
    }else{
      this.disableVar = false;
    }
  }


  verificaDias() {
    this.novosDiasExibir = "";

    if (this.exibirDia0) {
      this.novosDiasExibir += "0";
    }
    if (this.exibirDia1) {
      this.novosDiasExibir += "1";
    }
    if (this.exibirDia2) {
      this.novosDiasExibir += "2";
    }
    if (this.exibirDia3) {
      this.novosDiasExibir += "3";
    }
    if (this.exibirDia4) {
      this.novosDiasExibir += "4";
    }
    if (this.exibirDia5) {
      this.novosDiasExibir += "5";
    }
    if (this.exibirDia6) {
      this.novosDiasExibir += "6";
    }
    if(this.exibirDiaTodos){
      this.novosDiasExibir = "0123456";
    }
  }


  verificaDiasPush() {
    if (this.category.exibir_categoria_dias.includes("0")) {
      this.exibirDia0 = true;
    }
    if (this.category.exibir_categoria_dias.includes("1")) {
      this.exibirDia1 = true;
    }
    if (this.category.exibir_categoria_dias.includes("2")) {
      this.exibirDia2 = true;
    }
    if (this.category.exibir_categoria_dias.includes("3")) {
      this.exibirDia3 = true;
    }
    if (this.category.exibir_categoria_dias.includes("4")) {
      this.exibirDia4 = true;
    }
    if (this.category.exibir_categoria_dias.includes("5")) {
      this.exibirDia5 = true;
    }
    if (this.category.exibir_categoria_dias.includes("6")) {
      this.exibirDia6 = true;
    }
    if (this.category.exibir_categoria_dias.includes("0123456")) {
      this.exibirDiaTodos = true;
      this.disableVar = true;
    }
  }

  async pesquisarDominio() {
    let result = await this.apiUnidade.getByDominio(this.dominioDestino);
    if (result) {
      this.toast.showSucess('Domínio Encontrado');
      this.mostrarEnviar = true;
    } else {
      this.toast.showError('Ocorreu um erro ao tentar obter o domínio (dominio inválido ou desativado)');
    }
  }

  async enviarCopia() {
    try {
      let resultado = await this.apiCategoria.copiarCatLoja(this.category, this.dominioDestino, this.comOpcs);
      this.toast.showSucess('Categoria copiada com sucesso!');
      this.dominioDestino = "";
      this.catDestino = "";
      this.comOpcs = false;
      this.displayModal = false;
      this.mostrarEnviar = false;
      console.log(resultado);
    } catch (error) {
      this.toast.showError('Ocorreu um erro ao tentar copiar a Categoria');
      this.dominioDestino = "";
      this.catDestino = "";
      this.comOpcs = false;
      console.log(error);
    }



  }


  async openModal() {
    this.displayModal = true;
  }


  async confirmarExclusao(codigo) {
    this.loadProd(codigo);
    console.log(this.produtos);

    let alert
    if(this.produtos == null){
      console.log("if");
     alert = await this.alertController.create({
      header: 'Confirmar?',
      message: 'Tem certeza de que deseja exlcuir a Categoria? (A mesma não poderá ter nenhum produto!)',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.excluircat(codigo)
          }
        }
      ]
    });

  }else{
    console.log("Else");
     alert = await this.alertController.create({
      header: 'Atenção!',
      message: 'É necessário excluir os produtos antes de excluir a Categoria!',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }
      ]
    });

  }
  await alert.present();
  }


  excluircat(codigo) {
    let result = this.apiCategoria.excluir(codigo);
    this.router.navigate(['/categoria-list']);
  }

  async loadCategory(id: number) {
    this.category = await this.apiCategoria.getById(id);
    this.loadProd(this.category.id);
    this.verificaDiasPush();
  }


  async loadProd(idCat) {
    this.apiproduto.GetByCat(idCat).then(res => {
      this.produtos = res;
      return res;
      //this.toast.showSucess('Produtos obtidos com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter Produtos');
    });
  }



  async confirmarDuplicar(categoria) {
    const alert = await this.alertController.create({
      header: 'Duplicar Categoria',
      message: 'Tem certeza de que deseja duplicar esta Categoria?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.duplicarCategoria(categoria)
          }
        }
      ]
    });

    await alert.present();
  }


  async duplicarCategoria(categoria) {
    this.carregando = true;
    let result = await this.apiCategoria.duplicar(categoria);
    const categoriaID = result.id

    for (let index = 0; index < this.produtos.length; index++) {
      const element = this.produtos[index];

      console.log(element);
      console.log(element.posicao);

      let novoProduto = await this.apiproduto.duplicarPorCategoria(element, categoriaID, 0);

      for (let index2 = 0; index2 < this.produtos[index].opcionais2.length; index2++) {

        const element = this.produtos[index].opcionais2[index2];
        const result1 = await this.gruposOpcionalService.insertLigacaco2(novoProduto.id, element['id']);
      }

    }
    this.carregando = false;
    if(categoriaID > 0){
    this.router.navigate(['/categoria-editar/', categoriaID]);
    }
  }


  limpaImg() {
    this.category.img = '';
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    const body = JSON.stringify(this.category);
    // tslint:disable-next-line: max-line-length
    this.http.post(this.dominio + '/backend/api/v2/categoria/limpaImg', body, { headers }).subscribe((val) => {

    });
    return false;
  }

  validaSenha() {
    if (parseInt(this.validador) === this.senhaGerada) {
      this.validado = true;
    } else {
      this.toast.showError('Senha expirada ou inválida');
    }
  }

  editarCustom(){
    this.router.navigate(['/alterar-custom/', this.idCatParam]);
    
  }


  postMethod(files: FileList) {
    this.fileToUpload = files.item(0);
    // tslint:disable-next-line: prefer-const
    let formData = new FormData();
    formData.append('file', this.fileToUpload, this.fileToUpload.name);
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    // tslint:disable-next-line: max-line-length
    this.http.post(this.dominio + '/backend/api/v2/categoria/getImg', formData, { headers }).subscribe((val) => {
      this.imgPath = val;
      this.category.img = this.imgPath;
    });
    return false;
  }

  async onSubmit() {
    this.carregando = true;
    this.verificaDias();
    this.category.exibir_categoria_dias = this.novosDiasExibir;
    if (this.category.custom === "" || this.category.custom === null || this.category.custom === undefined) {
      this.category.custom = '{"tipo":"produto"}';
    } 
        if (JSON.parse(this.category.custom)["tipo"] === "pizza") {
          let resultadoAux = await this.unidadeService.setCategoriaExibicao();
        }

        try {
          const result = await this.apiCategoria.save(this.category);
          this.category.id = result.id;
          this.toast.showSucess('Categoria salva com sucesso');
          this.verificaDiasPush();
          this.carregando = false;
          this.router.navigate(['/categoria-editar/', result.id]);
        } catch (error) {
          this.carregando = false;
          console.log(error);
          this.toast.showError('Ocorreu um erro ao tentar salvar a Categoria');
        }
  }

  carregarRotas() {
    return this.apiCategoria.getRotas()
      .then(rotas => {
        this.rotas = rotas.map(c => {
          return ({ label: c.descricao_rota, value: c.descricao_rota });
          // tslint:disable-next-line: align
        });
        this.rotas.splice(0,0,{label: "Nenhuma", value: ""})
      })
      
      .catch(erro => {
        this.toast.showError('Erro ao carregar Categorias!');
      });
  }

}
